import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[customTooltip]'
})
export class CustomTooltipDirective {
  @Input('customTooltip') tooltipContent: string;
  tooltip: HTMLElement;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('mouseenter') onMouseEnter() {
    if (!this.tooltip) { this.showTooltip(); }
  }

  // @HostListener('mouseleave') onMouseLeave() {
  //   if (this.tooltip) { this.hideTooltip(); }
  // }

  showTooltip() {
    this.tooltip = this.renderer.createElement('div');
    this.renderer.addClass(this.tooltip, 'tooltip-text');
    this.tooltip.innerHTML = this.tooltipContent;
    this.renderer.appendChild(this.el.nativeElement, this.tooltip);
  }

  hideTooltip() {
    this.renderer.removeChild(this.el.nativeElement, this.tooltip);
    this.tooltip = null;
  }
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/my-working-report/custom-tooltip.directive.ts